import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, getFormValues, change } from 'redux-form';
import { connect } from 'react-redux';
import { validate } from '../lib/clientValidator';
import VxBasicInputField from './vxFields/VxBasicInputField';
import VxRadioField from './vxFields/VxRadioField';
import { BTN_FACTORY_FORM, BTN_FACTORY_MAX_PROGRAMS } from '../clientConstants';
import getLocaleMessages from '../utils/localesMessages';
import LogoComponent from './logo/LogoComponent';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import { isLoggedInUser } from '../utils/authUtils';
import { trackWizardStep } from '../utils/ButtonFactoryFPT';
import Programs from './programs/Programs';
import $ from 'jquery';

const {
	header,
	unhostedHeader,
	subTitle,
	advance,
	input: {
		orgName,
		purpose,
		program,
		receiverEmail
	},
	buttonIntentionNote
} = getLocaleMessages('buttons/wizardStepTwo');

const {
	options: {
		acctIdentifier,
		acctIdentifierPersonal
	}
} = getLocaleMessages('buttons/wizardStepFour');

const mapStateToProps = (state) => {
	const formValues = getFormValues(BTN_FACTORY_FORM)(state) || {};

	return {
		initialValues: state.buttonFactory.formattedButton,
		formValues,
		application: state.application,
		email: _get(state, 'application.accountIdentifier.email')
	}
}

class WizardStep2 extends Component {
	static propTypes = {
		handleSubmit: PropTypes.func,
		formValues: PropTypes.object,
		application: PropTypes.object,
		change: PropTypes.func,
		dispatch: PropTypes.func,
		email: PropTypes.string
	}

	componentDidMount() {
		$('.main-container').animate({ scrollTop: 0 }, 400);
				
		trackWizardStep({
			step: 2
		});
	}

	renderTextField = (props) => {
		return (
			<VxBasicInputField {...props} />
		)
	}

	addProgram = (newProgram) => {
		const programNames = this.getValue('programNames') || [];
		if (programNames.length < BTN_FACTORY_MAX_PROGRAMS) {
			const newProgramNames = [...programNames, newProgram];
			this.props.dispatch(change(BTN_FACTORY_FORM, 'programNames', newProgramNames));
			this.props.dispatch(change(BTN_FACTORY_FORM, 'newProgramName', ''));
		}
	}

	removeProgram = (index) => {
		const programNames = this.getValue('programNames');
		// ES6 spread operator did not work here.
		// newProgramNames = programNames.splice(index, 1);
		const newProgramNames = [];
		for (let i = 0; i < programNames.length; i++) {
			if (i !== index) {
				newProgramNames.push(programNames[i]);
			}
		}
		this.props.dispatch(change(BTN_FACTORY_FORM, 'programNames', newProgramNames));
	}

	renderPrograms = () => {
		return (
			<Programs
				addProgram={this.addProgram}
				removeProgram={this.removeProgram}
			/>
		)
	}

	getValue = (key) => {
		return this.props.formValues[key];
	}

	getApplicationValues = (key) => {
		return _get(this.props.application, key, false);
	}

	renderLogoField = () => {
		const useSettingsLogo = this.getValue('useSettingsLogo');
		const logoUrl = this.getValue('logoUrl');
		const settingsLogoUrl = this.getValue('settingsLogoUrl');

		return (
			<LogoComponent
				useSettingsLogo={useSettingsLogo}
				settingsLogoUrl={settingsLogoUrl}
				logoUrl={logoUrl}
			/>
		)
	}

	renderAccountIdentifier = () => {
		const accountIdentifierType = this.getValue('accountIdentifierType');
		const useEmailLabel = acctIdentifier.defaultAccount.replace('{email}', this.props.email);

		return (
			<div>
				<div className="optional-body">
					<p className="margin-top-1">{acctIdentifierPersonal.prompt}</p>
					<Field
						type="radio"
						id="accountIdentifierMerchant"
						name="accountIdentifierType"
						value="merchantAccountId"
						checkedValue={accountIdentifierType}
						component={this.renderAccountIdentifierType}
						label={acctIdentifier.personalAccount}
					/>
					<Field
						type="radio"
						id="accountIdentifierEmail"
						name="accountIdentifierType"
						value="emailAddress"
						checkedValue={accountIdentifierType}
						component={this.renderAccountIdentifierType}
						label={useEmailLabel}
					/>
				</div>
			</div>
		)
	}

	renderAccountIdentifierType = (props) => {
		return (
			<VxRadioField {...props} />
		)
	}

	render() {
		const { handleSubmit } = this.props;
		const isLoggedIn = isLoggedInUser(this.props.application);
		const isHosted = _includes(['BUSINESS', 'PREMIER'], this.getApplicationValues('userType'));
		const isBusinessAccount = this.getApplicationValues('userType') === 'BUSINESS';
		const isPersonalAccount = this.getApplicationValues('userType') === 'PERSONAL';
		const shouldShowLogoUrl = isLoggedIn && _includes(['BUSINESS'], this.getApplicationValues('userType'));
		const showV1Programs = this.getApplicationValues('enableProgram');
				
		return (
			<div className="wizard-step-container wizard-step-2-container">
				<div className="wizard-step-title">
					{isBusinessAccount ? header : unhostedHeader}
					{!isLoggedIn &&
						<div className="vx_text-legal">{subTitle}</div>
					}
				</div>
				<div className="wizard-body">
					<form onSubmit={handleSubmit} className="wizard-form">
						{shouldShowLogoUrl && this.renderLogoField()}

						{isLoggedIn && isPersonalAccount && this.renderAccountIdentifier()}

						<div className="input-block">
							{shouldShowLogoUrl &&
								<hr className="vx_hr wizard-2-hr" />
							}
							{isBusinessAccount &&
								<Field
									id="organizationName"
									name="organizationName"
									type="text"
									component={this.renderTextField}
									label={orgName}
									readOnly={true}
								/>
							}
							{!isLoggedIn &&
								<Field
									id="business"
									name="business"
									type="email"
									component={this.renderTextField}
									label={receiverEmail}
								/>
							}
							<Field
								id="purpose"
								name="purpose"
								type="text"
								component={this.renderTextField}
								label={purpose}
							/>
							{
								!showV1Programs &&
								<Field
									id="itemNumber"
									name="itemNumber"
									type="text"
									component={this.renderTextField}
									label={program}
								/>
							}

							{showV1Programs && isHosted && this.renderPrograms()}
						</div>

						<div className="intention-note" dangerouslySetInnerHTML={{ __html: buttonIntentionNote }}></div>
						<div className="wizard-footer-button">
							<button className="vx_btn" type="submit" onClick={handleSubmit} id="nextStep">
								{advance}
							</button>
						</div>
					</form>
				</div>
			</div>
		);
	}
}

let WizardStep2Form = reduxForm({
	form: BTN_FACTORY_FORM,
	keepDirtyOnReinitialize: true,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate
})(WizardStep2);

WizardStep2Form = connect(mapStateToProps)(WizardStep2Form);

export default WizardStep2Form;



// WEBPACK FOOTER //
// ./buttons/components/WizardStep2.js